import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  total: 0,
};

const supportTicketsSlice = createSlice({
  name: "supportTickets",
  initialState,
  reducers: {
    clearTickets: () => {
      return initialState;
    },

    refreshAndSetTickets: (state, action) => {
      return { ...action.payload };
    },
  },
});

export const { refreshAndSetTickets, clearTickets } =
  supportTicketsSlice.actions;
export default supportTicketsSlice.reducer;
